import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid';
import React from 'react';

interface Page {
  name: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
}
export interface BreadcrumbProps {
  pages: Page[];
  clickOnHome?: React.MouseEventHandler<HTMLSpanElement>;
}

export function Breadcrumb(props: BreadcrumbProps) {
  const { pages, clickOnHome } = props;
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-4">
        <li>
          <div>
            <span
              onClick={clickOnHome}
              className={`text-gray-400 hover:text-gray-500 ${
                clickOnHome ? 'cursor-pointer' : ''
              }`}
            >
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </span>
          </div>
        </li>
        {React.Children.toArray(
          pages.map((page) => (
            <li>
              <div className="flex items-center">
                <ChevronRightIcon
                  className="h-5 w-5 flex-shrink-0 text-gray-400"
                  aria-hidden="true"
                />
                <span
                  onClick={page.onClick}
                  className={`ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 ${
                    page.onClick ? 'cursor-pointer' : ''
                  }`}
                >
                  {page.name}
                </span>
              </div>
            </li>
          ))
        )}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
